import posthog from 'posthog-js';

export const publicAnalyticsOptions = {
  api_host: 'https://eu.i.posthog.com',
  defaults: '2026-05-30',
  autocapture: false,
  capture_pageview: 'history_change',
  capture_pageleave: true,
  disable_session_recording: true,
  person_profiles: 'never',
  ip_capture: false,
} as const;

export const initialiseAnalytics = () => {
  if (typeof window === 'undefined' || window.location.hostname === 'localhost') return;

  posthog.init('phc_1qt0AGkMfo8sBae6j0WqKBFdxjhqncWvbaKLuVde4Uz', publicAnalyticsOptions);
};
